import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const TABS = [
  { to: '/applications', label: 'Applications', key: 'applications' },
  { to: '/applications/pre-underwriting', label: 'Pre-Underwriting Logs', key: 'pre-underwriting' },
];

export default function ApplicationsSectionTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeKey = location.pathname.startsWith('/applications/pre-underwriting')
    ? 'pre-underwriting'
    : 'applications';

  return (
    <div className="flex items-center gap-1 bg-gray-800 rounded-lg p-1 w-fit">
      {TABS.map((tab) => {
        const active = activeKey === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => navigate(tab.to)}
            className={`px-3 py-1.5 text-xs rounded-md transition-colors ${
              active
                ? 'bg-gray-700 text-white'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
